import {loadable} from 'router/routes';
import {Page, fetchCity, foldWithSearchState, isMonthlyPage} from './utils';
import React from 'react';

const SearchMobileTransient = loadable(() =>
    import('search/SearchMobileTransient')
);
const SearchMobileMonthly = loadable(() =>
    import('search/SearchMobileMonthly')
);
const SearchDesktopTransient = loadable(() =>
    import('search/SearchDesktopTransient')
);
const SearchDesktopMonthly = loadable(() =>
    import('search/SearchDesktopMonthly')
);

// eslint-disable-next-line react/prop-types
const CityLegacy = ({configData: {isMobile}, isMonthly}) =>
    isMobile && isMonthly ? (
        <SearchMobileMonthly />
    ) : isMobile ? (
        <SearchMobileTransient />
    ) : isMonthly ? (
        <SearchDesktopMonthly />
    ) : (
        <SearchDesktopTransient />
    );

CityLegacy.getInitialState = async ({state, params, query, cookies, route}) => {
    const pathname = route?.location?.pathname || params?.city;
    const slug = pathname.split('/').filter(Boolean);
    const cleanedSlug = slug[slug.length - 1].replace(/-parking$/, '');
    const city = await fetchCity(state, cleanedSlug);
    const isMonthly = isMonthlyPage(route);

    if (isMonthly) {
        query.monthly = isMonthly;
    }

    const {
        data: {latitude, longitude, timezone},
    } = city;

    return foldWithSearchState({
        state: {...state, city},
        type: Page.CITY,
        latitude,
        longitude,
        timezone,
        query,
        cookies,
    });
};

export default CityLegacy;
